var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchpadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 115,
    viewBox: "0 0 112 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_4861)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.2422,
    y: 11.2325,
    width: 73.8073,
    height: 70.5415,
    rx: 4,
    fill: "url(#paint0_linear_2_4861)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_2_4861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8386 10.2154C10.016 16.3804 7.05081 29.3403 13.2168 39.1624C19.3829 48.9845 32.3397 51.9492 42.1624 45.7842C51.985 39.6192 54.9502 26.6593 48.7841 16.8372C42.6181 7.01563 29.6613 4.05092 19.8386 10.2154Z",
    fill: "url(#paint1_radial_2_4861)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8733 114.868C61.7346 114.868 52.5959 114.868 43.4876 114.868C36.9078 114.868 31.851 110.053 32.0034 103.955C32.1557 97.6812 37.6084 92.7206 44.0969 93.0124C47.3259 93.1583 50.0675 94.4422 52.1999 96.8058C52.6568 97.3018 53.0223 97.5644 53.8144 97.4769C59.1148 96.8349 63.5928 100.366 64.0802 105.531C64.2325 107.077 64.5066 108.507 65.847 109.557C66.6695 110.17 67.5833 110.52 68.6495 110.52C70.1726 110.52 71.6957 110.549 73.2188 110.52C75.7472 110.462 77.5445 108.915 77.7882 106.523C77.9405 105.005 78.1233 103.546 78.8544 102.175C80.6212 98.9359 84.2462 97.01 88.054 97.5061C88.9069 97.6228 89.3029 97.3894 89.8208 96.8349C93.2021 93.1583 98.5635 92.0494 103.102 94.0045C107.641 95.9887 110.505 100.862 109.926 105.531C109.317 110.229 105.631 113.905 100.544 114.781C99.7515 114.926 98.929 114.926 98.1066 114.926C89.0288 114.868 79.951 114.868 70.8733 114.868Z",
    fill: "url(#paint2_linear_2_4861)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0424 88.6502C73.95 88.6502 67.9489 88.6502 61.826 88.6502C61.1863 85.849 60.5161 83.0185 59.8764 80.1881C58.8711 75.7235 57.744 71.2882 56.8606 66.8237C54.8806 56.6399 60.4856 45.6682 69.9899 40.7076C70.7819 40.2991 71.3302 40.4158 72.0613 40.7952C81.9616 46.1059 87.2925 57.4569 84.825 68.1367C83.3324 74.6147 81.8397 81.1218 80.3471 87.5998C80.2861 87.9207 80.1643 88.2417 80.0424 88.6502ZM77.7882 64.4309C77.7578 60.7834 74.6811 57.8654 70.8733 57.9238C67.1264 57.9821 64.1411 60.8418 64.1107 64.4309C64.0802 68.0492 67.1569 71.0256 70.9342 71.0256C74.7725 71.0256 77.8187 68.0492 77.7882 64.4309Z",
    fill: "url(#paint3_linear_2_4861)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0228 70.8505C54.4241 76.8615 55.7339 82.6683 57.1047 88.5919C54.881 88.5919 52.7486 88.5919 50.4944 88.5919C50.2203 87.483 50.403 86.345 50.3726 85.207C50.3421 82.785 50.3726 80.3339 50.3726 77.912C50.403 75.3442 51.1646 73.0681 53.0228 70.8505Z",
    fill: "url(#paint4_linear_2_4861)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0587 71.0255C90.3381 72.5429 91.1301 74.2353 91.4043 76.1612C91.4957 76.8323 91.5261 77.5035 91.5261 78.2038C91.5261 81.647 91.5261 85.0902 91.5261 88.621C89.2719 88.621 87.1091 88.621 84.9463 88.621C85.0681 86.9869 88.5104 72.1343 89.0587 71.0255Z",
    fill: "url(#paint5_linear_2_4861)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9643 106.187C69.5326 103.795 68.1923 101.694 66.9738 99.5344C65.8771 97.5502 66.3645 95.3617 68.1009 94.0486C69.8068 92.7355 72.1524 92.7647 73.8583 94.0778C75.5642 95.4201 76.0516 97.6085 74.9549 99.5928C73.706 101.723 72.3961 103.824 70.9643 106.187Z",
    fill: "url(#paint6_linear_2_4861)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2184 64.4601C73.2184 65.6857 72.1827 66.6778 70.9032 66.6486C69.6848 66.6194 68.71 65.6565 68.71 64.4893C68.71 63.2637 69.7457 62.2716 71.0251 62.3008C72.2436 62.33 73.2184 63.2637 73.2184 64.4601Z",
    fill: "url(#paint7_linear_2_4861)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 29.4602C60 28.1406 46.7924 27.0708 30.5 27.0708C14.2076 27.0708 1 28.1406 1 29.4602",
    stroke: "url(#paint8_linear_2_4861)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_4861",
    x: 17.2422,
    y: 5.23254,
    width: 93.8071,
    height: 90.5415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_2_4861",
    x: 0.000488281,
    y: 0,
    width: 62,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4861",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_2_4861"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4861",
    x1: 105.109,
    y1: 117.045,
    x2: -7.33912,
    y2: -63.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_4861",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9338 46.2) rotate(-58.1915) scale(47.1129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF89E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#92D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991368,
    stopColor: "#89A7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_4861",
    x1: 119.75,
    y1: 90.5334,
    x2: 114.512,
    y2: 125.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B86E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_4861",
    x1: 89.044,
    y1: 35.0286,
    x2: 49.9313,
    y2: 79.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B86E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_4861",
    x1: 57.9502,
    y1: 68.8546,
    x2: 44.2084,
    y2: 78.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B86E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_4861",
    x1: 92.3486,
    y1: 69.046,
    x2: 78.8062,
    y2: 78.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B86E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_4861",
    x1: 76.6843,
    y1: 91.6035,
    x2: 66.3531,
    y2: 105.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B86E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_4861",
    x1: 73.7819,
    y1: 61.8109,
    x2: 70.8952,
    y2: 67.4431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B86E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_4861",
    x1: -7.5,
    y1: 29.9381,
    x2: 94.472,
    y2: 24.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.557292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B4DF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpadIcon);
export default __webpack_public_path__ + "static/media/launchpad-icon.405d30ae5e96ec13e1f54c7bad9a5a85.svg";
export { ForwardRef as ReactComponent };